<template>
  <responsive-drawer-header :hasDrawer="false"  :color="theme.appBar.other.color" :moduleUnreadCount="unreadCount" >
    <!-- <template v-slot:drawer-module-title> {{ mx_moduleTitle }}</template>
    <template v-slot:drawer-subtitle
      >{{ questionnaireTitle }}
    </template> -->

    <template v-slot:left-module-title>{{ contentTitle }}</template>
    <template v-slot:left-subtitle>{{ contentSubtitle }}</template>

    <template v-slot:right>
    </template>
  </responsive-drawer-header>
</template>

<script>
import common from '@/mixins/common';
import { mapState } from 'vuex';
import ResponsiveDrawerHeader from '@/layouts/ResponsiveDrawerHeader.vue';

export default {
  name: 'BegleitfahrtResultViewHeader',
  components: {
    ResponsiveDrawerHeader,
  },
  mixins: [common],

  computed: {
    ...mapState('begleitfahrt', ['questionnaireById', 'unreadCount','userById','ratingById']),
    questionnaires() {
      return Object.values(this.questionnaireById).map((q) => {
        return { id: q.id, title: q.title };
      });
    },
    currentQuestionnaire(){
      const routeRatingId = this.$route.params.ratingId;
      // Check ratingById exists and is not empty and routeRatingId is not empty
      if (Object.keys(this.ratingById).length > 0 && routeRatingId) {
        if (this.ratingById[routeRatingId]) {
          if (this.ratingById[routeRatingId].questionnaireIdFk) {
            const questionnaireId = this.ratingById[routeRatingId].questionnaireIdFk
            return this.questionnaireById[questionnaireId]
          }
        }
      }
      return null;
    },
    userId() {
      return this.$route.params.userId;
    },
    user(){
      return this.userById[this.userId]
    },
    rating(){
      return this.ratingById[this.$route.params.ratingId]
    },
    contentTitle(){
      return this.$t('bf.result');
    },
    contentSubtitle(){
      const firstName = this.user && this.user.firstname || ''
      const lastName = this.user && this.user.lastname || ''
      if (this.currentQuestionnaire && this.user) {
        return `${this.currentQuestionnaire.title}: ${firstName} ${lastName}`;
      } else if (this.user) {
        return `${firstName} ${lastName}`;
      }
      return '';
    },
    subtitle(){
      if (this.rating){
        return {evaluation:this.$t('bf.evaluationAcronym'),questionnaire:this.$t('bf.assessment')}[this.rating.isType];
      }
      return 'no rating'
    }
  },
  methods: {
    randomUUID() {
      return crypto.randomUUID();
    },
  },
};
</script>
